module.exports = __webpack_public_path__ + "static/media/nameBot.348274dc.png";